<template>
  <div class="slide_layout">
    <el-row class="row-bg" :span="20" type="flex" justify="center" visibility="hide">
      <el-col :xs="19" :sm="14" :md="8" :lg="8" :xl="6" class="m-t-40 desktop_menu">
        <span class="slide_text"><br/></span>
        <div class="container_img">
          <!-- <div class="slide_tag rotate" :background-color="bgColor()">Фитнесс зөвлөгөө</div> -->
          <div class="slide_tag rotate" :style="'background-color:'+ bgColor()">Фитнесс зөвлөгөө</div>
          <span class="slide_text"><br/>
            <div class="m-l-40">
              <el-checkbox>Үр дүнтэй дасгалуудыг сонго</el-checkbox><br/>
              <el-checkbox>Илчлэгээс их зүйл шалтгаална</el-checkbox><br/>
              <el-checkbox>Өглөө эрт бос</el-checkbox><br/>
              <el-checkbox>Аль болох илүүг хий</el-checkbox><br/>
              <el-checkbox>Ус сайн уу</el-checkbox><br/>
              <el-checkbox>Цагаа хуваа</el-checkbox>
            </div>
          </span>
        </div>
      </el-col>
      <el-col :xs="10" :sm="10" :md="14" :lg="8" :xl="8" >
        <iframe class="achaa_img m-t-60" width="600" height="400" src="https://www.facebook.com/plugins/video.php?height=314&href=https%3A%2F%2Fwww.facebook.com%2Fsaruulbatlodonbaa%2Fvideos%2F1614180132809176%2F&show_text=false&width=560&t=0" title="Халамцуу Яриа-66 Л.Саруулбат  #EPISODE66" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin"></iframe>
        <!-- <el-image class="achaa_img" style="width: 500px" :src="giir" fit="cover"></el-image> -->
      </el-col>
      <!-- <el-col :xs="19" :sm="14" :md="8" :lg="8" :xl="6" class="m-t-40">
        <span class="slide_text"><br/></span>
        <div class="container_img">
          <div class="slide_tag rotate">{{$t('sliderbigtext')}}</div>
          <span class="slide_text"><br/>
            <div class="m-l-40">
              <el-checkbox>{{$t('shippingservices')}}</el-checkbox><br/>
              <el-checkbox>{{$t('orderservice')}}</el-checkbox><br/>
              <el-checkbox>{{$t('supplyservice')}}</el-checkbox><br/>
              <el-checkbox>{{$t('deliveryservice')}}</el-checkbox><br/>
              <el-checkbox>{{$t('productresearch')}}</el-checkbox>
            </div>
          </span>
        </div>
      </el-col>
      <el-col :xs="10" :sm="10" :md="14" :lg="8" :xl="8" class="desktop_menu">
        <el-image class="achaa_img" style="width: 500px" :src="logo" fit="cover"></el-image>
      </el-col> -->
    </el-row>
  </div>
</template>
<script>
import Logo from '@/assets/slide_1.png'
import Giir from '@/assets/giir.png'

export default {
  name: 'SlideComponent',
  data: function () {
    return {
      logo: Logo,
      giir: Giir
    }
  },
  methods: {
    whichWebFunction () {
      if (window.location.hostname === 'iteever.mn') {
        return 'hidden'
      } else if (window.location.hostname === 'eruulhun.com') {
        return 'hidden'
      } else if (window.location.hostname === 'localhost') {
        return 'hidden'
      }
    },
    bgColor () {
      if (window.location.hostname === 'www.iteever.mn') {
        return '#5E1EE5'
      } else if (window.location.hostname === 'www.eruulhun.com') {
        return '#64a29f'
      } else if (window.location.hostname === 'localhost') {
        return '#64a29f'
      }
    }
  }
}

</script>

<style>
.video-wrapper {
  position: relative;
  width: 560px;
  height: 315px;
}
.video-thumbnail {
  width: 100%;
  height: 100%;
  cursor: pointer;
}
#youtube-video {
  position: absolute;
  top: 0;
  left: 0;
}
 .achaa_img{
  border-radius: 30px;
 }
@media all and (min-width: 1400px) {
  .container_img{
      margin-left: 400px;
    }
}
@media all and (min-width: 1200px) {
  .container_img{
      margin-left: 300px;
    }
}
@media all and (max-width: 992px) {
  .container_img{
      margin-left: 200px;
    }
}
@media all and (max-width: 992px) {
  .achaa_img{
      margin-left: 100px;
    }
}
@media all and (min-width: 768px) {
  .container_img{
      margin-left: 50px;
    }
}
@media all and (min-width: 768px) {
  .achaa_img{
      margin-left: 100px;
    }
}
@media all and (max-width: 576px) {
  .container_img{
      margin-left: -15px;
    }
}
@media all and (max-width: 576px) {
  .achaa_img{
      margin-left: -15px;
      width: 350px !important;
    }
}
</style>
